import { DrawerCloseButton, RegPlate, VehicleDetailsCard } from '@components';
import { useView } from '@hooks';
import { Vehicle } from '@services';
import { Drawer, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface IProps {
  open: boolean;
  vehicle: Vehicle | undefined;
  onClose: () => void;
}

/**
 * Everything we hold on a vehicle, opened from the short vehicle summary on the customer card.
 * The order screen used to give this its own tab; a drawer keeps the tab bar for the job itself.
 */
export const VehicleDetailsDrawer: React.FC<IProps> = ({ open, vehicle, onClose }) => {
  const { isMobile } = useView();

  const makeAndModel = `${vehicle?.combinedMake ?? ''} ${vehicle?.combinedModel ?? ''}`.trim();

  return (
    <Drawer
      // The plate and model identify the drawer, so the body need not repeat them.
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
          {vehicle?.registrationNumber && <RegPlate>{vehicle.registrationNumber}</RegPlate>}
          {makeAndModel && (
            <Text
              type="secondary"
              style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {makeAndModel}
            </Text>
          )}
        </span>
      }
      open={open}
      onClose={onClose}
      styles={{ wrapper: { width: isMobile ? '100%' : 800 } }}
      destroyOnHidden
      extra={<DrawerCloseButton onClick={onClose} />}
      closable={false}
    >
      {/* Two label/value pairs per row (one on a phone): the drawer is narrow, so the grid grows
          downwards rather than squeezing four pairs into a line. */}
      {vehicle && (
        <VehicleDetailsCard
          vehicle={vehicle}
          bordered={false}
          hideHeader
          descriptionColumns={isMobile ? 1 : 2}
          descriptionLabelWidth={150}
        />
      )}
    </Drawer>
  );
};
